<template>
  <a-spin :spinning="loading">
    <a-card :bordered="false">
      <a-form :form="form" >
        <a-row>
          <a-col :span="24">
            <a-divider orientation="left">
              合同信息
            </a-divider>
          </a-col>
          <a-col :span="12">
            <a-form-item label="系统编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['business_no', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="合同号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['contract_number', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="合同名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input allow-clear v-decorator="['contract_name', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" placeholder="名称" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="运输公司名称" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-input allow-clear v-decorator="['shipping_company', {rules: [{required: false, message: '必填项，请填写信息'}, {max:128, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              支付信息
            </a-divider>
          </a-col>
          <a-col :span="12">
            <a-form-item label="支付方式" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-select
                v-decorator="[
                  'payment_method',
                  {
                    rules: [
                      { required: true, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="选择"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.trade_payment_method">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="计费方式" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-input allow-clear v-decorator="['billing_method', {rules: [{required: false, message: '必填项，请填写信息'}, {max:64, message: '输入超出长度限制'}]}]" placeholder="请输入" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="支付周期" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-input allow-clear v-decorator="['payment_cycle', {rules: [{required: false, message: '必填项，请填写信息'}, {max:64, message: '输入超出长度限制'}]}]" placeholder="请输入" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="滞期费规定" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-input allow-clear v-decorator="['demurrage_terms', {rules: [{required: false, message: '必填项，请填写信息'}, {max:256, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="速遣费规定" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-input allow-clear v-decorator="['despatch_terms', {rules: [{required: false, message: '必填项，请填写信息'}, {max:256, message: '输入超出长度限制'}]}]" placeholder="请输入" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="免堆期" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-input-number allow-clear v-decorator="['free_demurrage_days', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="请输入" :min="0" />（天）
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              财务信息
            </a-divider>
          </a-col>
          <a-col :span="12">
            <a-form-item label="税率" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-input-number allow-clear v-decorator="['tax_rate', {initialValue: 0, rules: [{required: true, message: '必填项，请填写信息'}]}]"/>%
            </a-form-item>
          </a-col>
        </a-row>
        <a-form-item v-bind="buttonCol">
          <a-row>
            <a-col offset="8" span="6">
              <a-button type="primary" html-type="submit" @click="handleSubmit">提交</a-button>
            </a-col>
            <a-col span="10">
              <a-button @click="handleGoBack">返回</a-button>
            </a-col>
          </a-row>
        </a-form-item>
      </a-form>
    </a-card>
  </a-spin>
</template>

<script>
import moment from 'moment'
import pick from 'lodash.pick'
import { booking_contract_create, booking_contract_list } from '@/api/trade_contract'
export default {
  name: 'TableEdit',
  props: {
    record: {
      type: [Object, String],
      default: ''
    }
  },
  data () {
    return {
      labelCol: {
        xs: { span: 6 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12, offset: 5 }
        }
      },
      form: this.$form.createForm(this),
      id: 0,
      sell_contract_id: 0,
      loading: false,
      type: 0,
      data: {},
      fields: ['business_no', 'contract_number', 'contract_name', 'shipping_company',
        'demurrage_terms', 'despatch_terms', 'free_demurrage_days', 'billing_method', 'payment_cycle', 'payment_method', 'tax_rate']
    }
  },
  mounted () {
    this.loadContract()
  },
  methods: {
    moment,
    handleGoBack () {
      this.$router.go(-1)
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    loadContract () {
      this.loading = true
      booking_contract_list({ id: this.$route.params.id }).then(res => {
        const list = res.data.entries
        if (list && list.length > 0) {
          this.data = list[0]
          this.id = this.data.id
          this.loadEditInfo(this.data)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handleSubmit () {
      const { form: { validateFields } } = this
      validateFields((err, values) => {
        console.log('我要提交接口', values, err)
        if (!err) {
          if (values['free_demurrage_days'] === null) {
            values['free_demurrage_days'] = 0
          }
          values['project_id'] = this.data.project_id
          values['sell_contract_id'] = this.sell_contract_id
          this.loading = true
          booking_contract_create(values).then((res) => {
            if (res.code === 1000) {
              this.handleGoBack()
              console.log(res, '修改成功')
            }
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
    loadEditInfo (data) {
      const { form } = this
      console.log(`将加载 ${this} 信息到表单`)
      new Promise((resolve) => {
        setTimeout(resolve, 0)
      }).then(() => {
        const formData = pick(data, this.fields)
        formData.payment_method = '' + formData.payment_method
        this.id = data.id
        this.sell_contract_id = data.sell_contract_id
        form.setFieldsValue(formData)
      })
    }
  }
}
</script>
